<template>
  <section>
    <h3 class="mb-2">
      {{ $translate('ENTER_YOUR_PERSONAL_DETAILS') }}
    </h3>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          :label="$translate('FIRSTNAME')"
          v-model="userInfo.firstName"
          required
          outlined
          hide-details="auto"
          :rules="requiredRules"
          @change="onUserInfoChange"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          :label="$translate('LASTNAME')"
          v-model="userInfo.lastName"
          required
          outlined
          hide-details="auto"
          :rules="requiredRules"
          @change="onUserInfoChange"
        />
      </v-col>
      <v-col
        v-if="event.Type === 'Delivery' || event.Type === 'Shiplee'"
        cols="12"
      >
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="userInfo.postalCode"
              :loading="loadingAddress"
              :disabled="loadingAddress"
              :label="$translate('POSTAL_CODE')"
              :rules="postalCodeRules"
              outlined
              hide-details="auto"
              @change="onPostalCodeChange"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="userInfo.houseNo"
              :loading="loadingAddress"
              :disabled="loadingAddress"
              :label="$translate('HOUSE_NUMBER')"
              :rules="requiredRules"
              outlined
              hide-details="auto"
              @change="onHouseNoChange"
            />
          </v-col>

          <v-col cols="12" v-if="false" class="pt-0 mt-2">
            <v-row class="mb-1">
              <h4 class="pl-3">{{ $translate('DELIVERY_ADDRESS') }}</h4>
              <a class="pl-2" @click="editCityAndStreetData">{{
                $translate('EDIT')
              }}</a>
            </v-row>
            {{ userInfo.street }} {{ userInfo.houseNo }}<br />
            {{ userInfo.postalCode }} {{ userInfo.city }}
          </v-col>
          <v-col cols="12" v-if="noConfidenceInAddress === true">
            <v-alert text dense type="info">
              {{ $translate('NO_CONFIDENCE_ADDRESS') }}
            </v-alert>
          </v-col>
          <v-col cols="12" md="6" v-if="editCityAndStreet">
            <v-text-field
              v-model="userInfo.street"
              :disabled="!editCityAndStreet"
              :label="$translate('STREET')"
              :rules="requiredRules"
              outlined
              hide-details="auto"
              @change="onUserInfoChange"
            />
          </v-col>
          <v-col cols="12" md="6" v-if="editCityAndStreet">
            <v-text-field
              v-model="userInfo.city"
              :disabled="!editCityAndStreet"
              :label="$translate('CITY')"
              :rules="requiredRules"
              outlined
              hide-details="auto"
              @change="onUserInfoChange"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="userInfo.countryCode"
              :label="$translate('COUNTRY')"
              :rules="requiredRules"
              :items="countryCodes"
              :disabled="countryCodes.length === 1"
              @change="onUserInfoChange"
              hide-details="auto"
              outlined
            >
              <template slot="item" slot-scope="data">
                {{ getCountryName(data.item, { select: 'official' }) }}
              </template>
              <template slot="selection" slot-scope="data">
                {{ getCountryName(data.item, { select: 'official' }) }}
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="userInfo.email"
          :label="$translate('EMAIL')"
          :rules="emailInputRules"
          disabled
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="userIsLoggedIn && userInfo.email === ''">
        <v-text-field
          v-model="confirmEmail"
          :label="$translate('CONFIRM_EMAIL')"
          :rules="confirmEmailRules"
          outlined
          hide-details="auto"
          @change="onUserInfoChange"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="userInfo.phoneNo"
          :label="$translate('PHONE_NR')"
          :rules="phoneNrInputRules"
          required
          outlined
          hide-details="auto"
          @change="onUserInfoChange"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="userInfo.note"
          :label="$translate('REMARK_OPTIONAL')"
          rows="2"
          hide-details="auto"
          outlined
          @change="onUserInfoChange"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
import forwardGeocoding from '@/api/Geocoding';
import { requiredRules, emailRules } from '@/shared/validations_rules';

// import countries from 'i18n-iso-countries';
let countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/nl.json'));
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));

export default {
  name: 'DeliveryPickUpUserInfo',
  components: {},
  props: {
    // Delivery / pickup event
    event: Object,
    user: Object,
    countryCodes: Array,
  },
  data() {
    return {
      userInfo: {},
      confirmEmail: '',
      requiredRules,
      postalCodeRules: [
        ...requiredRules,
        (v) =>
          (v != null &&
            /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(v.trim()) &&
            this.userInfo.countryCode === 'NL') ||
          this.userInfo.countryCode !== 'NL' ||
          'Postal code must be valid',
      ],
      emailInputRules: [...requiredRules, ...emailRules],
      confirmEmailRules: [
        ...requiredRules,
        ...emailRules,
        (v) => v === this.userInfo.email || this.$translate('EMAIL_NO_MATCH'),
      ],
      phoneNrInputRules: [
        ...requiredRules,
        // ...phoneNumberRules,
      ],
      loadingAddress: false,
      showCityAndStreet: false,
      editCityAndStreet: true,
      noConfidenceInAddress: false,
      addedLocale: false,
    };
  },
  computed: {
    userIsLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    userObjectId() {
      return this.userIsLoggedIn
        ? this.$store.getters['auth/userName']
        : this.$store.getters['auth/tmpUserId'];
    },
  },
  watch: {
    user() {
      this.initUserInfo();
    },
    countryCodes() {
      this.setDefaultCountry();
    },
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    setDefaultCountry() {
      if (this.countryCodes.length === 0) return;
      if (this.countryCodes.includes(this.userInfo.countryCode)) return;

      // If the user does not have a country then NL will be picked if it is available
      if (this.countryCodes.includes('NL')) {
        this.userInfo.countryCode = 'NL';
      }
    },
    getCountryName(code, selection) {
      let locale = '';
      switch (Number(this.$store.getters['auth/userLanguage'].LanguageId)) {
        case 13:
          locale = 'en';
          break;
        case 14:
          locale = 'nl';
          break;
        case 17:
          locale = 'de';
          break;
        default:
          locale = 'en';
      }
      // if (!this.addedLocale) {
      //   countries.registerLocale(
      //     require(`i18n-iso-countries/langs/${locale}.json`)
      //   );
      //   this.addedLocale = true;
      // }
      return countries.getName(code, locale, selection);
    },
    initUserInfo() {
      this.userInfo = {};
      if (this.user != null) {
        this.userInfo = { ...this.user };
      }
      this.setDefaultCountry();

      if (this.userIsLoggedIn) {
        this.showCityAndStreet = true;
      } else {
        this.showCityAndStreet = false;
      }
    },
    getUserInfo() {
      return {
        Name: `${this.userInfo.firstName} ${this.userInfo.lastName}` || '',
        Email: this.userInfo.email || '',
        PhoneNumber: this.userInfo.phoneNo || '',
        Street: this.userInfo.street || '',
        Nr: this.userInfo.houseNo || '',
        PostalCode: this.userInfo.postalCode || '',
        City: this.userInfo.city || '',
        Country: this.userInfo.country || '',
        CountryCode: this.userInfo.countryCode || '',
        Latitude:
          this.userInfo.latitude == null ? -200 : this.userInfo.latitude,
        Longitude:
          this.userInfo.longitude == null ? -200 : this.userInfo.longitude,
      };
    },
    getGeocodeLocation() {
      this.noConfidenceInAddress = false;
      this.showCityAndStreet = false;
      this.editCityAndStreet = false;
      this.userInfo.street = '';
      this.userInfo.city = '';
      if (
        this.userInfo.postalCode.length !== 0 &&
        this.userInfo.houseNo.length !== 0
      ) {
        this.geocodeAddress();
      }
    },
    geocodeAddress() {
      // Get gps location based on user's address info if Delivery needed
      const userAddressObj = this.getUserInfo();
      this.loadingAddress = true;
      this.$emit('loading', true);

      forwardGeocoding(
        userAddressObj,
        (result) => {
          // Geocoding finished successfully
          this.loadingAddress = false;
          this.$emit('loading', false);
          if (result.Latitude != null) {
            this.userInfo.latitude = result.Latitude;
          }
          if (result.Longitude != null) {
            this.userInfo.longitude = result.Longitude;
          }

          this.userInfo.city = result.City;
          this.userInfo.street = result.Street;
          this.onUserInfoChange();

          if (result.Confident) {
            this.showCityAndStreet = true;
            this.editCityAndStreet = false;
            this.noConfidenceInAddress = false;
          } else {
            this.showCityAndStreet = false;
            this.editCityAndStreet = true;
            this.noConfidenceInAddress = true;
          }
        },
        () => {
          // Geocoding finished with error
          this.loadingAddress = false;
          this.$emit('loading', false);
        }
      );
    },
    editCityAndStreetData() {
      this.showCityAndStreet = false;
      this.editCityAndStreet = true;
    },
    onPostalCodeChange() {
      // disabled because api is not giving right result
      // this.getGeocodeLocation();
      this.onUserInfoChange();
    },
    onHouseNoChange() {
      // disabled because api is not giving right result
      // this.getGeocodeLocation();
      this.onUserInfoChange();
    },
    onUserInfoChange() {
      this.$emit('change', this.userInfo);
    },
  },
};
</script>
